module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGNDA1MiIgZD0iTTEzLjY1NyAyLjM0M0E4IDggMCAxIDEgMi4zNDMgMTMuNjU3IDggOCAwIDAgMSAxMy42NTcgMi4zNDMiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik03LjIgNC44YS44LjggMCAxIDEgMS42IDBWOGEuOC44IDAgMSAxLTEuNiAwVjQuOHpNOCAxMmEuOC44IDAgMSAxIDAtMS42LjguOCAwIDAgMSAwIDEuNnoiLz4KICAgIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/error.svg
// module id = I8Y8
// module chunks = 1